import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ContainerWithItems } from '../../../components/container-with-items/container-with-items';
import { EventProvider } from '../../../providers/event/event';

@Component({
  selector: 'page-event-list',
  templateUrl: 'event-list.html',
})
export class EventListPage {
  container: ContainerWithItems;
  pagination = {
    limit: 20, 
    page: 1,
    start: 0
  };
  
  constructor(public navCtrl: NavController, public navParams: NavParams, private eventService: EventProvider) {
    this.container = navParams.data.container;
  }

  loadNextPage(paginator) {
    this.pagination.page += 1;
    this.pagination.start += this.pagination.limit;

    this.getEventsByEventTypeEventArea(this.eventService.activeEventType, this.container.eventArea, this.pagination).then((events:any) => {
      this.container.items.push(...events);
      if (paginator) paginator.complete();
    });
  }

  getEventsByEventTypeEventArea(eventType: string, eventArea: string, pagination: any) {
    return new Promise((resolve, reject) => {
      this.eventService.getEventSimple(eventType, eventArea, pagination).then(events => {
        let uniqueEvents = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
        uniqueEvents = uniqueEvents.slice(0, pagination.limit);
        resolve(uniqueEvents);
      });
    })
  }
}



// WEBPACK FOOTER //
// /src/pages/event/event-list/event-list.ts